import { render, staticRenderFns } from "./AnnualSaleComponent.vue?vue&type=template&id=1154d118"
import script from "./AnnualSaleComponent.vue?vue&type=script&lang=js"
export * from "./AnnualSaleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports